import { Injectable } from '@angular/core';
import { CorrectionData, Corrections, GeometryResponse, GPSFilePoints } from 'src/app/data/model/gps-address-data';
import { GpsFilePointsApiService } from 'src/app/shared/api/services/gps-file-points-api.service';
import { BaseEntityService } from 'src/app/shared/base/base-entity.service';
import * as L from 'leaflet';
import { PortalGroupApiService } from 'src/app/shared/api/services/portal-group-api.service';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, tap } from 'rxjs';
import { PortalGroup } from 'src/app/data/model/portal-group';
import { NoGpsPointsDialogComponent } from '../../map/components/no-gps-points.component';

@Injectable({
  providedIn: 'root'
})
export class WaypointsLapMapDialogService extends BaseEntityService<
GPSFilePoints,
GpsFilePointsApiService
> {
  updatePoint(layer: L.FeatureGroup<any>, data: GPSFilePoints) {
    throw new Error('Method not implemented.');
  }
  myicon =  L.Icon.extend({
    options:
      {
        iconSize: [14, 24], // size of the icon 21, 31
        iconAnchor: [8, 20], // 8, 24 point of the icon which will correspond to marker's location
        popupAnchor: [0, -51],  
        iconUrl: '../../../../assets/images/gps.png'
      }
    })

  start_icon =  L.Icon.extend({
    options:
      {
        iconSize: [14, 24], // size of the icon 21, 31
        iconAnchor: [8, 20], // 8, 24 point of the icon which will correspond to marker's location
        popupAnchor: [0, -51],  
        iconUrl: '../../../../assets/images/start.png'
      }
  })

  finish_icon =  L.Icon.extend({
    options:
      {
        iconSize: [14, 24], // size of the icon 21, 31
        iconAnchor: [8, 20], // 8, 24  10, 24point of the icon which will correspond to marker's location
        popupAnchor: [0, -51],  
        iconUrl: '../../../../assets/images/finish.png'
      }
  })

  marker_icon =  L.Icon.extend({
    options:
      {
        iconSize: [14, 24], // size of the icon 21, 31
        iconAnchor: [8, 20], // 8, 24 point of the icon which will correspond to marker's location
        popupAnchor: [0, -51],  
        iconUrl: '../../../../assets/images/mark.png',
        shadowUrl: '../../../../assets/images/markshadow.png'
      }
    })

  bin_icon =  L.Icon.extend({
    options:
      {
        iconSize: [32, 32], // size of the icon 21, 31
        iconAnchor: [8, 20], // 8, 24 point of the icon which will correspond to marker's location
        popupAnchor: [0, -51],  
        iconUrl: '../../../../assets/images/bin.png'
      }
    })

  constructor(
    apiService: GpsFilePointsApiService,
    private portalGroupService: PortalGroupApiService,
    private dialog:MatDialog
  ) {
    super(apiService);
  }

  private groupsSubject = new BehaviorSubject<PortalGroup[] | null>(null);
  private geometrySubject = new BehaviorSubject<GeometryResponse | null>(null);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  loading$=this.loadingSubject.asObservable();

  get groups$() {
    return this.groupsSubject.asObservable();
  }

  get geometry_response$() {
    return this.geometrySubject.asObservable();
  }

  setLoading(loading: boolean) {
    this.loadingSubject.next(loading);
  }
  
  getLoading(): boolean {
    return this.loadingSubject.getValue();
  }

  private openNoGpsPointsDialog(): void {
    this.dialog.open(NoGpsPointsDialogComponent, {
      width: '300px',
      data: { message: 'Non ci sono dati disponibili.' }//il mezzo selezionato non riporta nessun punto GPS
    });
  }

  loadGroup() {
    this.portalGroupService
      .getAll()
      .pipe(tap((res:any) => this.groupsSubject.next(res.results)))
      .subscribe();
  }

  orderPoints(corrections:CorrectionData) {
    this.apiService
    .orderPoints(corrections)
    .pipe(tap((res:any) =>{
      this.geometrySubject.next(res as GeometryResponse);
      this.setLoading(false);
    }))
    .subscribe();
  }


  setIcon(type:String){
    if (type === 'start') {
      return L.Icon.extend({
        options:
          {
            iconSize: [21, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/start.png'
          }
        })
    } else if (type === 'stop') {
      return L.Icon.extend({
        options:
          {
            iconSize: [21, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/finish.png'
          }
        })
    } else {
      return L.Icon.extend({
        options:
        {
          iconSize: [21, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/marker-icon.png',
          shadowUrl: '../../../../assets/images/markshadow.png'
        }
        })
    }
  }

  loadLastPoint(markers: L.FeatureGroup, point:GPSFilePoints) {
    markers.clearLayers();
    if(point.gps_point_item?.real_coords) {
      var coords = point.gps_point_item?.real_coords?.split(" ");
      var mark1:string[]= coords[1].split("(");
      var mark2:string[]= coords[2].split(")");
      var data:string="<div><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Targa: "+point.file+"</td></tr></table></div>";
      const point_icon=this.setIcon('standard');
      var marker = L.marker([Number(mark1[1]), Number(mark2[0])],{icon: new point_icon} //[mark2[0], mark1[1]]
      ).bindPopup(data, {closeButton: false});
      markers.addLayer(marker);
    } else {
      this.openNoGpsPointsDialog();
    }
  }

  private decode(str: string, precision:number): L.LatLngExpression[]{
    var index = 0,
        lat = 0,
        lng = 0,
        coordinates:L.LatLng[] = [],
        shift = 0,
        result = 0,
        byte = null,
        latitude_change,
        longitude_change,
        factor = Math.pow(10, precision || 6);

    // Coordinates have variable length when encoded, so just keep
    // track of whether we've hit the end of the string. In each
    // loop iteration, a single coordinate is decoded.
    while (index < str.length) {

        // Reset shift, result, and byte
        byte = null;
        shift = 0;
        result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

        shift = result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

        lat += latitude_change;
        lng += longitude_change;
        const latitude=lat / factor
        const longitude=lng / factor
        coordinates.push(L.latLng(latitude, longitude));
    }

    return coordinates;
 }

  setWayPoints(markers: L.FeatureGroup, data:GeometryResponse){
    const markerClusterGroup = L.markerClusterGroup();
    if(data.steps.length ===0){
      this.openNoGpsPointsDialog();
    }
    else {

      data.steps.forEach(step => {
        const [lat, lng] = step.street_coords;
        if (step.order === 0){
          const start_icon=this.setIcon('start');
          const marker = L.marker([lat, lng], {icon: new start_icon}).addTo(markerClusterGroup);
          marker.bindPopup(`<b>Address:</b> ${step.address} <b>order:</b> ${step.order}`);
        } else if (step.order === data.steps.length-1){
          const finish_icon=this.setIcon('stop');
          const marker = L.marker([lat, lng], {icon: new finish_icon}).addTo(markerClusterGroup);
          marker.bindPopup(`<b>Address:</b> ${step.address} <b>order:</b> ${step.order}`);

        }else {
          const icon=this.setIcon('stanard');
          const marker = L.marker([lat, lng],  {icon: new icon}).addTo(markerClusterGroup);
          marker.bindPopup(`<b>Address:</b> ${step.address} <b>order:</b> ${step.order}`);
        }
      });
      markerClusterGroup.addTo(markers)
      L.polyline(this.decode(data.geometry, 5), { color: 'blue' }).addTo(markers);
    }
    this.loadingSubject.next(false);

  }

}